<template>
    <div style="margin-top: 60px">
        <div>

            <app-bar :menu="appMenu"
                     @addToMenu="_addToMenu"
            >
                <template v-slot:action>
                    <v-btn v-if="isAdmin" icon @click="addGame">
                        <v-icon color="green" size="30">mdi-plus-circle</v-icon>
                    </v-btn>
                    <v-btn icon @click="getGames">
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                </template>

            </app-bar>


            <v-tabs class="mb-3 mx-0 top-fixed" v-model="tab" color="black" background-color="white" grow>
                <v-tab class="text-uppercase py-5" v-for="(item,i) in items" :key="i">
                    <v-icon class="mr-3">{{ item.icon }}</v-icon>
                    {{ item.text }}
                </v-tab>
            </v-tabs>

            <v-tabs-items class="ma-3" v-model="tab" style="background-color: rgba(0,0,0,0)">
                <v-tab-item v-for="(item,i) in items" :key="i">

                    <v-container class="text-center pa-0">
                        <v-row no-gutters>
                            <v-col cols="3" @click="openInfo(0)">
                                <v-avatar
                                        color="#1e7e34"
                                        size="18"
                                ></v-avatar>
                                <br>
                                <small>Allenamento</small>
                            </v-col>
                            <v-col cols="3" @click="openInfo(1)">
                                <v-avatar
                                        color="#e0a609"
                                        size="18"
                                ></v-avatar>
                                <br>
                                <small>Amichevole</small>
                            </v-col>
                            <v-col cols="3" @click="openInfo(2)">
                                <v-avatar
                                        color="#ff5333"
                                        size="18"
                                ></v-avatar>
                                <br>
                                <small>Evento</small>
                            </v-col>
                            <v-col cols="3" @click="openInfo(3)">
                                <v-avatar
                                        color="#5f9ea0"
                                        size="18"
                                ></v-avatar>
                                <br>
                                <small>Altro</small>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-card flat tile color="rgba(0,0,0,0)">

                        <loader numb="5" :show="!allDataLoaded"></loader>
                        <v-row justify="center" v-if="allDataLoaded">

                            <div class="text-center white--text pa-5" v-if="getList.length === 0">
                                <v-icon class="d-block rem4" color="white">mdi-check</v-icon>
                                <span class="subtitle-1">Non abbiamo trovato giocate!</span><br><br>
                            </div>

                            <v-col v-else cols="12 py-1" v-for="(game,i) in getList" :key="i">
                                <game-list :game="game"
                                           :isAdmin="isAdmin"
                                           @delete="deleteItem"
                                           @edit="edit"
                                           @extract="archive"
                                           @archive="archive"
                                           @vote="getAnswers"
                                >
                                </game-list>
                            </v-col>

                            <v-btn class="mt-5 body-2" v-if="isAdmin && tab === 0" x-large @click="addGame">
                                <v-icon class="mr-3" color="green">mdi-plus-circle</v-icon>
                                Aggiungi nuova votazione
                            </v-btn>

                            <v-alert v-if="!isAdmin && tab === 0" class="ma-5" type="info">
                                <small>Invita il tuo presidente o admin della pagina a creare una nuova giocata!</small>
                            </v-alert>

                        </v-row>

                    </v-card>
                </v-tab-item>
            </v-tabs-items>


            <v-dialog
                    v-model="editMode"
                    fullscreen
                    transition="dialog-bottom-transition"
                    @close="console.log('asf')"
            >
                <v-card tile>
                    <v-toolbar dark>
                        <v-btn icon dark @click="closeDialog">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Modifica Giocata</v-toolbar-title>
                    </v-toolbar>

                    <div class="pa-4" v-if="game">

                        <v-stepper v-model="step" vertical>
                            <v-stepper-step
                                    :complete="step > 1"
                                    step="1"
                                    editable
                            >
                                Giorno e Ora
                                <small>Seleziona data e orario della giocata</small>
                            </v-stepper-step>

                            <v-stepper-content step="1">

                                <v-dialog
                                        ref="dialogDate"
                                        v-model="pickerDate"
                                        :return-value.sync="game.date"
                                        persistent
                                        width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                                outlined
                                                v-model="game.date"
                                                label="Data della Giocata"
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                class="mt-2"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                            v-model="game.date"
                                            :first-day-of-week="1"
                                            :min="now"
                                            scrollable
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="pickerDate = false"
                                        >
                                            Annulla
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="black"
                                                @click="$refs.dialogDate.save(game.date)"
                                        >
                                            Scegli
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>

                                <v-dialog
                                        ref="dialogHour"
                                        v-model="pickerHour"
                                        :return-value.sync="game.hour"
                                        persistent
                                        width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                                outlined
                                                v-model="game.hour"
                                                label="Ora inizio giocata"
                                                prepend-inner-icon="mdi-clock-time-four-outline"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                            v-if="pickerHour"
                                            v-model="game.hour"
                                            full-width
                                            format="24hr"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="pickerHour = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="black"
                                                @click="$refs.dialogHour.save(game.hour)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>

                                <v-dialog
                                        ref="dialogHourEnd"
                                        v-model="pickerHourEnd"
                                        :return-value.sync="game.end_hour"
                                        persistent
                                        width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                                outlined
                                                v-model="game.end_hour"
                                                label="Ora fine giocata"
                                                prepend-inner-icon="mdi-clock-time-four-outline"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                            v-if="pickerHourEnd"
                                            v-model="game.end_hour"
                                            full-width
                                            format="24hr"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="pickerHourEnd = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="black"
                                                @click="$refs.dialogHourEnd.save(game.end_hour)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>

                                <v-btn color="secondary" @click="step = 2">
                                    Continua
                                </v-btn>
                            </v-stepper-content>

                            <v-stepper-step
                                    :complete="step > 2"
                                    step="2"
                                    editable
                            >
                                Dettagli Giocata
                            </v-stepper-step>

                            <v-stepper-content step="2">

                                <v-select
                                        class="mt-2"
                                        v-model="game.type"
                                        :items="gameType"
                                        label="Tipologia giocata"
                                        outlined
                                ></v-select>

                                <v-text-field
                                        label="Nome Giocata"
                                        outlined
                                        v-model="game.title"
                                ></v-text-field>

                                <v-textarea
                                        label="Descrizione Giocata"
                                        outlined
                                        v-model="game.description"
                                ></v-textarea>

                                <v-select
                                        v-model="game.setup"
                                        :items="gameSetup"
                                        label="Scelta Setup"
                                        outlined
                                ></v-select>

                                <v-text-field v-if="game.setup === 'squadra'"
                                              label="Quale Setup?"
                                              outlined
                                              v-model="game.other"
                                ></v-text-field>

                                <v-btn color="secondary" @click="step = 3">
                                    Continua
                                </v-btn>
                            </v-stepper-content>

                            <v-stepper-step
                                    :complete="step > 3"
                                    step="3"
                                    editable
                            >
                                Scadenza Votazioni
                            </v-stepper-step>

                            <v-stepper-content step="3">

                                <v-dialog
                                        ref="dialogExpiredDate"
                                        v-model="pickerExpiry"
                                        :return-value.sync="game.expiry_date"
                                        persistent
                                        width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                                class="mt-2"
                                                outlined
                                                v-model="game.expiry_date"
                                                label="Data chiusura Votazioni"
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                            :max="game.date"
                                            :min="now"
                                            v-model="game.expiry_date"
                                            :first-day-of-week="1"
                                            scrollable
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="pickerExpiry = false"
                                        >
                                            Annulla
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="black"
                                                @click="$refs.dialogExpiredDate.save(game.expiry_date)"
                                        >
                                            Scegli
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>

                                <v-dialog
                                        ref="dialogHourExp"
                                        v-model="pickerHourExp"
                                        :return-value.sync="game.expiry_time"
                                        persistent
                                        width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                                outlined
                                                v-model="game.expiry_time"
                                                label="Ora scadenza"
                                                prepend-inner-icon="mdi-clock-time-four-outline"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                            v-if="pickerHourExp"
                                            v-model="game.expiry_time"
                                            full-width
                                            format="24hr"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                text
                                                color="primary"
                                                @click="pickerHourExp = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                                text
                                                color="black"
                                                @click="$refs.dialogHourExp.save(game.expiry_time)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>

                                <v-btn color="secondary" @click="step = 4">
                                    Continua
                                </v-btn>
                            </v-stepper-content>

                            <v-stepper-step
                                    :complete="step > 4"
                                    step="4"
                                    editable
                            >
                                Quorum e Scelte Disponibili
                            </v-stepper-step>
                            <v-stepper-content step="4">

                                <v-text-field
                                        class="mt-2"
                                        label="Quorum Minimo"
                                        outlined
                                        v-model="game.min_quorum"
                                ></v-text-field>

                                <!--<v-combobox-->
                                        <!--class="mt-2"-->
                                        <!--v-model="game.answers"-->
                                        <!--chips-->
                                        <!--clearable-->
                                        <!--label="Scelte disponibili"-->
                                        <!--multiple-->
                                        <!--outlined-->
                                <!--&gt;-->
                                    <!--<template v-slot:selection="{ attrs, item, select, selected }">-->
                                        <!--<v-chip-->
                                                <!--close-->
                                                <!--v-bind="attrs"-->
                                                <!--:input-value="selected"-->
                                                <!--@click="select"-->
                                                <!--@click:close="removeAnswer(item)"-->
                                        <!--&gt;-->
                                            <!--<strong>{{ item }}</strong>&nbsp;-->
                                        <!--</v-chip>-->
                                    <!--</template>-->
                                <!--</v-combobox>-->

                                <div class="justify-space-between d-flex align-center">
                                    <div>Aggiungi le opzioni:</div>
                                    <div>
                                        <v-btn @click="addAnswer" color="warning">
                                            <v-icon>mdi-plus</v-icon> Aggiungi
                                        </v-btn>
                                    </div>
                                </div>

                                <v-text-field
                                        @keyup.enter="addAnswer"
                                        class="mt-2"
                                        label="Inserisci opzione e premi invio o aggiungi ..."
                                        outlined
                                        v-model="choice"
                                ></v-text-field>


                                <v-list v-if="game.answers.length > 0" subheader>
                                    <v-subheader>Lista opzioni:</v-subheader>

                                    <v-list-item
                                            v-for="c in game.answers"
                                            :key="c"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title v-text="c"></v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-btn icon @click="removeAnswer(c)">
                                                <v-icon color="red">mdi-delete-circle</v-icon>
                                            </v-btn>
                                        </v-list-item-action>

                                    </v-list-item>
                                </v-list>

                            </v-stepper-content>
                        </v-stepper>

                        <v-btn color="success" block class="mt-4" x-large @click="save">
                            <v-icon>mdi-check</v-icon>
                            Salva
                        </v-btn>

                        <v-snackbar
                                timeout="-1"
                                color="red"
                                outlined
                                absolute
                                v-model="errors.length"
                        >
                            <b>Ops! ci sono degli errori:</b>
                            <ul class="text-small">
                                <li v-for="error in errors">{{ error }}</li>
                            </ul>

                            <template v-slot:action="{ attrs }">
                                <v-btn
                                        color="pink"
                                        text
                                        v-bind="attrs"
                                        @click="errors = []"
                                >
                                    Close
                                </v-btn>
                            </template>
                        </v-snackbar>

                    </div>


                </v-card>

            </v-dialog>

        </div>

        <v-bottom-sheet v-model="openVote" close-delay="2000">
            <v-sheet>
                <div class="py-3">

                    <div class="text-center">
                        <h3>Vota per la giocata del {{formattingData(game.date,true)}}</h3>
                        <p class="body-1">{{game.title}}</p>

                        <div class="mx-2 mb-4">
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        Dettagli Giocata
                                        <template v-slot:actions>
                                            <v-icon color="primary">
                                                mdi-information-outline
                                            </v-icon>
                                        </template>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <p class="body-2 text-left" style="max-height: 200px; overflow: scroll">
                                            {{game.description}}
                                        </p>

                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>


                    </div>

                    <v-item-group mandatory>
                        <loader v-if="voting" numb="2"></loader>
                        <div v-if="!voting">
                            <v-virtual-scroll
                                    :items="game.answers"
                                    max-height="400"
                                    item-height="110"
                            >
                                <template v-slot:default="{ item }">

                                    <v-card outlined flat class="text-center mx-2">
                                        <div class="mt-2 text-uppercase"><b>{{ item }}</b> - <small>Totale voti:</small> <b>{{votationTot(item)}}</b></div>
                                        <div class="pb-2 d-flex align-center">
                                            <avatar-list :avatars="votationList(item)"></avatar-list>
                                            <v-spacer></v-spacer>
                                            <v-btn v-if="!expired()" @click="vote(game.container_id, item)" fab small
                                                   class="mr-4">
                                                <v-icon>mdi-check</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-card>

                                </template>
                            </v-virtual-scroll>
                        </div>
                    </v-item-group>
                </div>
            </v-sheet>
        </v-bottom-sheet>


        <v-dialog v-model="info_dialog.status">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    {{info_dialog.title}}
                </v-card-title>

                <v-card-text class="pt-5">
                    {{info_dialog.text}}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="info_dialog.status = false"
                    >
                        Ok Capito
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </div>
</template>

<script>

    import axios from 'axios';
    import {mapMutations, mapActions, mapGetters} from 'vuex'
    import gameList from '../components/game/itemList'
    import avatarList from '../components/avatar/avatarList'

    export default {
        name: 'Home',
        components: {
            gameList,
            avatarList,
        },
        data: () => ({
            info_dialog: {
                status: false,
                title: '',
                text: '',
                content: [
                    {
                        title: 'Allenamento',
                        text: 'Generalmente una giocata tra compagni di squadra, per allenarsi con tattiche e modalità nuove di gioco!'
                    },
                    {
                        title: 'Amichevole',
                        text: 'Giocata organizzata tra uno o più teams amici!'
                    },
                    {
                        title: 'Evento',
                        text: 'Torneo o Evento organizzato da voi, o al quale partecipate!'
                    },
                    {
                        title: 'Altro',
                        text: 'Qualsiasi altro tipo di evento, che può anche esulare dallo stesso softair, lasertag o speedsoft che sia!'
                    },
                ]
            },
            choice: null,
            step: 1,
            now: new Date().toISOString().substr(0, 10),
            pickerDate: false,
            pickerHour: false,
            pickerHourEnd: false,
            pickerHourExp: false,
            pickerExpiry: false,
            editMode: false,
            mode: 'new',
            actionMenu: [
                {text: 'Modifica', icon: 'mdi-file-edit', action: 'edit'},
                {text: 'Elimina', icon: 'mdi-delete', action: 'delete'},
                {text: 'Archivia', icon: 'mdi-folder-zip', action: 'archive'},
            ],
            gameType: ['Allenamento', 'Amichevole', 'Evento', 'Altro'],
            gameSetup: ['squadra', 'libero'],

            appMenu: [
                //{text: 'Aggiungi al Menù', icon: 'mdi-pin', action: 'addToMenu'},
            ],
            tab: null,
            items: [
                {text: 'in programma', icon: 'mdi-clock-time-seven'},
                {text: 'archiviate', icon: 'mdi-folder-zip'}
            ],
            allDataLoaded: false,
            games: [],
            errors: [],
            game: false,
            votation: false,
            voting: false,
            gameStruct: {
                club_id: 0,
                date: '',
                hour: '',
                end_hour: '',
                type: '',
                title: '',
                description: '',
                setup: '',
                other: '',
                min_quorum: 0,
                expiry_date: '',
                expiry_time: '00:00',
                answers: [],
                archived: 0
            },
            member_id: false,
            club_id: false,
            openVote: false,
        }),
        mounted() {
            this.member_id = parseInt(localStorage.getItem('_mID'));
            this.club_id = parseInt(localStorage.getItem('_cID'));
            setTimeout(() => {
                this.getGames();
                this.gameStruct.club_id = this.club_id;
            }, 100);
        },
        computed: {
            ...mapGetters([
                'getMemberID',
                'getClubID',
                'getMainClubID',
                'isAdmin',
            ]),
            getList() {
                return this.games.filter(game => {
                    return (game.archived === 1) === (this.tab === 1);
                });
            },
        },
        methods: {
            addAnswer() {
                if(!this.choice){
                    return false;
                }
                let str = this.choice.trim();
                if(this.game.answers.includes(str) || str === null || str === ''){
                    return false;
                }
                this.game.answers.push(str);
                this.choice = null;
            },
            removeAnswer(item) {
                this.game.answers.splice(this.game.answers.indexOf(item), 1);
                this.game.answers = [...this.game.answers];
            },
            openInfo(id) {
                this.info_dialog.status = true;
                this.info_dialog.title = this.info_dialog.content[id].title;
                this.info_dialog.text = this.info_dialog.content[id].text;
            },
            ...mapMutations([
                'setLoading',
                'setFlash',
            ]),
            ...mapActions([
                '_addToMenu'
            ]),
            closeDialog() {
                this.editMode = false;
                this.game = false;
            },
            closeVote() {
                this.openVote = false;
                this.game = false;
            },
            getGames() {
                if (this.club_id) {
                    this.allDataLoaded = false;
                    let data = {club_id: this.club_id};
                    //console.log(data);
                    axios
                        .post(this.$store.state.ROOT_API + '/club/game/get', data,
                            {
                                headers: {
                                    'Authorization': 'Bearer ' + this.$store.getters.getToken
                                }
                            })
                        .then(resp => {
                            this.games = resp.data.games;
                            this.allDataLoaded = true;
                            //console.log(resp.data);
                        })
                        .catch((error) => {
                            console.error(error)
                        })
                } else {
                    this.setFlash('Errore caricamento Club Data...');
                }
            },
            addGame() {
                this.mode = 'new';
                this.editMode = true;
                this.game = this.gameStruct;
                // dovrebbe eliminare dalla vista l'elemento

            },
            edit(id) {
                this.mode = 'edit';
                this.games.forEach((g, i) => {
                    if (g.container_id === id) {
                        this.game = this.games[i];
                        if (!Array.isArray(this.game.answers)) {
                            this.game.answers = this.game.answers.split(','); // creo array delle risposte
                        }
                        this.editMode = true;
                    }
                });
            },
            deleteItem(id) {
                if (confirm('Sicuro che vuoi eliminarlo?')) {
                    axios
                        .post(this.$store.state.ROOT_API + '/club/game/delete', {container_id: id},
                            {
                                headers: {
                                    'Authorization': 'Bearer ' + this.$store.getters.getToken
                                }
                            })
                        .then(resp => {
                            this.setFlash(resp.data.msg);
                            this.getGames();
                        })
                        .catch((error) => {
                            console.error(error)
                        })
                }
            },
            getAnswers(id) {
                this.loadVotation(id);
                this.openVote = true;
                this.games.forEach((g, i) => {
                    if (g.container_id === id) {
                        this.game = this.games[i];
                        if (!Array.isArray(this.game.answers)) {
                            this.game.answers = this.game.answers.split(','); // creo array delle risposte
                        }
                    }
                });
            },
            expired() {
                let now = new Date();
                let d = new Date(this.game.expiry_date + 'T' + this.game.expiry_time);
                return (now > d || (now === d && now.getHours() >= d.getHours() && now.getMinutes() > d.getMinutes()));
            },
            vote(game_id, choice) {

                if (this.expired()) {
                    alert('Ops, la votazione è scaduta!');
                    this.closeVote();
                    this.getGames();
                    return;
                }

                let data = {game_id: game_id, choice: choice, user_id: this.member_id};
                //console.log(data);
                axios
                    .post(this.$store.state.ROOT_API + '/club/game/vote',
                        data,
                        {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getToken
                            }
                        })
                    .then(resp => {
                        this.setFlash(resp.data.msg);
                        this.getAnswers(game_id)
                    })
                    .catch((error) => {
                        console.error(error)
                    });
            },
            archive(id) {
                axios
                    .post(this.$store.state.ROOT_API + '/club/game/archive', {container_id: id},
                        {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getToken
                            }
                        })
                    .then(resp => {
                        if (resp.data.state) {
                            this.getGames();
                            this.tab = this.tab === 1 ? 0 : 1;
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                    });
            },

            save() {
                this.errors = [];
                let now = new Date();
                let d1 = new Date(this.game.date);
                let d2 = new Date(this.game.expiry_date);

                if (!this.game.date) {
                    this.errors.push('Devi indicare una data per la giocata!');
                }

                if (!this.game.hour) {
                    this.errors.push('Devi indicare l\'ora di inizio della giocata!');
                }

                if (this.game.date && d1.getTime() < now.getTime()) {
                    this.errors.push('DOC sei tu?... no? allora non puoi organizzare una giocata nel passato!');
                }

                if (this.game.expiry_date && d2.getTime() > d1.getTime()) {
                    this.errors.push('La data di scadenza deve essere antecedente alla data della giocata!');
                    //this.game.expiry_date = this.game.date;
                }

                if (!this.game.expiry_date && this.game.date) {
                    this.game.expiry_date = d1.setDate(d1.getDate() - 1);
                }

                if (!this.game.type) {
                    this.errors.push('Devi indicare il tipo di giocata!');
                }
                if (!this.game.title) {
                    this.errors.push('Devi inserire un titolo per la giocata');
                }
                if (this.game.description.length < 3) {
                    this.errors.push('La descrizione deve contenere almeno 3 caratteri');
                }
                if (!this.game.setup) {
                    this.errors.push('Devi selezionare una tipologia di setup di gioco');
                }
                if (isNaN(this.game.min_quorum)) {
                    this.errors.push('Il quorum deve essere un numero!');
                }
                if (this.game.answers.length <= 0) {
                    this.errors.push('Devi indicare le scelte per le votazioni!');
                }

                if (!this.errors.length) {
                    this.submitForm();
                }
            },

            submitForm() {
                this.setLoading(true);
                this.allDataLoaded = false;
                this.game.action = this.mode;
                this.game.send_mail_status = this.mode === 'new';
                this.game.date = this.formattingData(this.game.date);
                this.game.expiry_date = this.formattingData(this.game.expiry_date);
                this.game.type = this.game.type.toLowerCase();
                this.game.other = (this.game.setup === 'libero') ? '' : this.game.other;
                let data = this.game;
                this.closeDialog();

                // console.log(data);
                // return false;

                axios
                    .post(this.$store.state.ROOT_API + '/club/game/update', data,
                        {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getToken
                            }
                        })
                    .then(resp => {
                        //console.log(resp.data);
                        this.setLoading(false);
                        this.getGames();
                    })
                    .catch((error) => {
                        console.error(error)
                    });
            },

            formattingData(d, inverted = false) {
                const toTwoDigits = num => num < 10 ? '0' + num : num;
                let today = new Date(d);
                let year = today.getFullYear();
                let month = toTwoDigits(today.getMonth() + 1);
                let day = toTwoDigits(today.getDate());
                if (inverted) {
                    return `${day}/${month}/${year}`;
                }
                return `${year}-${month}-${day}`;
            },

            loadVotation(id) {
                this.voting = true;
                axios
                    .post(this.$store.state.ROOT_API + '/club/game/load', {game_id: id},
                        {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getToken
                            }
                        })
                    .then(resp => {
                        this.votation = resp.data;
                        this.voting = false;
                        //console.log(this.votation);
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },

            votationList(choice) {
                let mapped = [];
                this.votation.forEach(i => {
                    if (i.choice === choice) {
                        mapped = (i.members);
                    }
                });
                return mapped;
            },

            votationTot(choice) {
                let tot = 0;
                this.votation.forEach(i => {
                    if (i.choice === choice) {
                        tot = i.tot
                    }
                });
                return tot;
            }
        }
    }
</script>

<style scoped>
    .top-fixed {
        position: fixed;
        top: 56px;
        z-index: 1;
    }

    .rem4 {
        font-size: 4rem;
    }
</style>